<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <div style="text-align:left">
        OOO!
    </div>
  </div>
</template>

<script>


export default {
  name: 'HelloWorld',
  components: {

  },
  data(){
    return {
      todos:[],
    }
  },
  props: {
    msg: String
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
